import { render, staticRenderFns } from "./CollectPaymentModal.vue?vue&type=template&id=118eb5ce&scoped=true"
import script from "./CollectPaymentModal.vue?vue&type=script&lang=js"
export * from "./CollectPaymentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118eb5ce",
  null
  
)

export default component.exports